<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container >
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item :label="language['system.certificate.certificateDescribe']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="certificateDescribe">
              <a-input v-model="model.certificateDescribe" :disabled="disabled||islock"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['system.certificate.system']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="systemCode">
              <a-select v-model="model.systemCode" allowClear @change="systemCodeChange" :disabled="disabled||islock">
                <a-select-option v-for="(item,index) in systemlist" :key="index" :value="item.systemCode">{{item.systemName}}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['system.certificate.cbCode']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="cbCode">
              <a-auto-complete
                allowClear
                @change="cbCodeChange"
                :disabled="disabled||islock"
                v-model="model.cbCode"
                :data-source="cbCodelist"
                :filter-option="filterOption"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['system.certificate.mrcCode']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="mrcCode">
              <a-auto-complete
                allowClear
                @change="mrcCodeChange"
                :disabled="disabled||islock"
                v-model="model.mrcCode"
                :data-source="mrcCodelist"
                :filter-option="filterOption"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['system.certificate.certificateLegalperson']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="certificateLegalperson">
              <!--              <a-input v-model="model.certificateLegalperson"  ></a-input>-->
              <a-auto-complete
                allowClear
                @change="certificateLegalpersonChange"
                :disabled="disabled||islock"
                v-model="model.certificateLegalperson"
                :data-source="certificateLegalpersonlist"
                :filter-option="filterOption"
              />
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row>
          <!--          <a-col :span="5">文件</a-col>-->
          <a-col :span="24">
            <a-form-model-item :label="language['common.file']+'('+(totalFileSize/1024/1024).toFixed(2)+'M)'" :labelCol="labelCol" :wrapperCol="wrapperCol" >
              <div v-if="!disabled&&!islock&&(totalFileSize>maxFileSize)"><span style='color: red'>* {{language['sysCertificate.warning.totalFileSizeIs']}}:{{(totalFileSize/1024/1024).toFixed(2)}}M;{{language['sysCertificate.warning.CannotExceed']}}{{maxFileSize/1024/1024}}M</span></div>
              <div v-if="!disabled&&!islock&&(fileList.length>maxFileNumber)"><span style='color: red'>* {{ language['sysCertificate.warning.totalFileNumberIs'] }}:{{fileList.length}} {{language['common.pcs']}};{{language['sysCertificate.warning.CannotExceed']}}{{maxFileNumber}} {{language['common.pcs']}},{{language['sysCertificate.warning.uploadCompressedFiles']}}</span></div>
              <div v-if="disabled">
                <div v-if="!!this.model.filePaths">
                  <j-upload file-type="file" :uploadSource="`platform`" bizPath="null"
                            :newWindowOpen="`true`" :value="this.model.filePaths" @change="handleChange"
                            :beforeUpload="beforeUpload" @getAllFileList="getAllFileList" @handleDelete="handleFileDelete" :disabled="disabled"
                            :buttonVisible="!disabled&&!islock&&(totalFileSize<=maxFileSize)&&(fileList.length<=maxFileNumber)" :number="0" :multiple="true"></j-upload>
                </div>
                <div v-else>{{language['common.not']}}</div>
              </div>
              <div v-if="!disabled">
                <j-upload file-type="file" :text="this.language['common.clickUpload']" :uploadSource="`platform`" bizPath="null" :uploadTips="uploadTips"
                          :newWindowOpen="`true`" :value="this.model.filePaths" @change="handleChange"
                          :beforeUpload="beforeUpload" @getAllFileList="getAllFileList" @handleDelete="handleFileDelete" :disabled="islock"
                          :buttonVisible="!disabled&&!islock&&(totalFileSize<=maxFileSize)&&(fileList.length<=maxFileNumber)" :number="0" :multiple="true"></j-upload>
              </div>

              <a-button type="primary" v-if="!!this.model.filePaths"  @click="downLoadAll">{{language['common.all']+language['download']}}</a-button>
            </a-form-model-item>
          </a-col>
        </a-row>

      </a-form-model>
    </j-form-container>
    <!--    <div style="text-align: center" v-if="!disabled">
          <span style='color: #8c8c8c'>
             {{language['sysCertificate.warning.totalFileMaxNumber']}} {{maxFileNumber}} {{language['common.pcs']}},{{language['sysCertificate.warning.uploadCompressedFiles']}};{{language['sysCertificate.warning.totalFileMaxSize']}} {{maxFileSize/1024/1024}}M
          </span>
        </div>-->
  </a-spin>
</template>

<script>

  import { httpAction, getAction,getFileAccessHttpUrl,downloadFile,downloadFileAll } from '@/api/manage'
  const getFileName=(path)=>{
    if(path.lastIndexOf("\\")>=0){
      let reg=new RegExp("\\\\","g");
      path = path.replace(reg,"/");
    }
    return path.substring(path.lastIndexOf("/")+1);
  }
  export default {
    name: 'SysCertificateCbCodeForm',
    components: {
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      },
      systemlist:{
        type:[String,Array],
        required:false,
      },
      islock:{
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        // maxFileSize:100,
        maxFileSize:500*1024*1024,
        maxFileNumber:50,
        datalist:[],
        mrcCodelist:[],//管报代码list
        cbCodelist:[],//财报代码list
        certificateLegalpersonlist:[],
        model:{},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          systemCode: [
            { required: true, message: this.$store.getters.language['common.pleaseInput']+this.$store.getters.language['system.certificate.system']},
          ],
          mrcCode: [
            { required: true, message: this.$store.getters.language['common.pleaseInput']+this.$store.getters.language['system.certificate.mrcCode']},
            { min: 0, max: 100, message: this.$store.getters.language['common.lengthUnder']+ 100 +this.$store.getters.language['common.character'], trigger: 'blur' },
          ],
          cbCode: [
            { required: true, message: this.$store.getters.language['common.pleaseInput']+this.$store.getters.language['system.certificate.cbCode']},
            { min: 0, max: 100, message: this.$store.getters.language['common.lengthUnder']+ 100 +this.$store.getters.language['common.character'], trigger: 'blur' },
          ],
          certificateLegalperson: [
            { required: true, message: this.$store.getters.language['common.pleaseInput']+this.$store.getters.language['system.certificate.certificateLegalperson']},
            { min: 0, max: 100, message: this.$store.getters.language['common.lengthUnder']+ 100 +this.$store.getters.language['common.character'], trigger: 'blur' },
          ],
          certificateDescribe: [
            { required: true, message: this.$store.getters.language['common.pleaseInput']+this.$store.getters.language['system.certificate.certificateDescribe']},
            { min: 0, max: 100, message: this.$store.getters.language['common.lengthUnder']+ 100 +this.$store.getters.language['common.character'], trigger: 'blur' },
          ],
        },
        url: {
          add: "/sys/syscertificate/add",
          edit: "/sys/syscertificate/edit",
          queryById: "/system/syscertificate/"
        },
        totalFileSize:0,
        fileList:[],
        // islock:false,
        lockConfig:'',
      }
    },
    computed: {
      /*fileList(){
        this.fileList.forEach(item=>{
          this.filePath.push(item.filePath);
        })
      },*/
      language() {
        return this.$store.getters.language
      },
      formDisabled(){
        return this.disabled
      },
      uploadTips(){
        return this.language['sysCertificate.warning.totalFileMaxNumber']+' '+this.maxFileNumber+' '+this.language['common.pcs']+","+this.language['sysCertificate.warning.uploadCompressedFiles']+';'+this.language['sysCertificate.warning.totalFileMaxSize']+' '+ (this.maxFileSize/1024/1024)+'M';
      }
    },
    created () {
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      /*getLockConfig(){
        getAction("/sys/basedata/tBmConfig/queryValueByKey",{systemCode:v}).then(res=>{
            if(res.success){
              this.lockConfig = res.result;
            }
        })
      },*/
      downLoadAll(){
        if(this.model.filePaths){
          /*let fileList = this.model.filePaths.split(",");
          let urls = [];
          for (var i=0;i<fileList.length;i++){
            let filepath = fileList[i];
            let url = getFileAccessHttpUrl(filepath,'platform');
            // downloadFile(url,filepath);
            urls.push(url);
          }
          if(urls.length>0)downloadFile("/sys/common/downLoadAll?applicationCode=platform"+"&token="+Vue.ls.get(ACCESS_TOKEN),fileList,{fileNames:this.model.filePaths});*/
          downloadFileAll('platform',this.model.filePaths,this)
        }
      },
      filterOption(input, option) {
        return option.componentOptions.children[0].text.toUpperCase().indexOf(input.toUpperCase()) >= 0
      },
      systemCodeChange(v){
        let that = this
        that.datalist = [];
        that.certificateLegalpersonlist = [];
        that.mrcCodelist = []//管报代码list
        that.cbCodelist = []//财报代码list
        // if(that.model.certificateLegalperson)that.model.certificateLegalperson = ''
        if(v){
          getAction("/sys/syscertificatelegalpersonsystems/getDataBySystemCode",{systemCode:v}).then(res=>{
            if(res.success){
              // this.queryParam.certificateLegalpersonId = '';
              let list = res.result;
              if(list){
                that.datalist = list;
                let keys = [];
                list.forEach(item=>{
                  if(keys.indexOf(item.cbCode)==-1) {
                    keys.push(item.cbCode);
                    that.cbCodelist.push({value:item.cbCode,text:item.cbCode})
                  }
                })
                if(that.cbCodelist.length==1){
                  that.model.cbCode = that.cbCodelist[0].value
                  that.cbCodeChange(that.model.cbCode)
                }
              }

            }
          })
        }
      },
      cbCodeChange(value){
        let that = this
        that.mrcCodelist = []//管报代码list
        that.certificateLegalpersonlist = [];
        if(value){
          let keys = [];
          that.datalist.forEach(item=>{
            if(item.cbCode == value&&keys.indexOf(item.mrcCode)==-1){
              keys.push(item.mrcCode);
              that.mrcCodelist.push({value:item.mrcCode,text:item.mrcCode})
            }
          })
          if(that.mrcCodelist.length==1){
            that.model.mrcCode = that.mrcCodelist[0].value;
            that.mrcCodeChange(that.model.mrcCode);
          }
        }
      },
      mrcCodeChange(value){
        let that = this
        that.certificateLegalpersonlist = [];
        if(value){
          let keys = [];
          that.datalist.forEach(item=>{
            if(item.mrcCode == value&&keys.indexOf(item.legalperson)==-1){
                keys.push(item.legalperson);
              that.certificateLegalpersonlist.push({value:item.legalperson,text:item.legalperson})
            }
          })
          if(that.certificateLegalpersonlist.length==1){
            that.model.certificateLegalperson  = that.certificateLegalpersonlist[0].text;
          }
        }

      },
      certificateLegalpersonChange(value){
        // this.model.certificateLegalperson  = value;
      },
      handleChange(value,files){
        this.model.filePaths = value;
        let that = this
        let arr = that.fileList;
        this.totalFileSize = 0;
        this.fileList = [];
        if(files){
          for (let i=0;i< files.length;i++){
            if(files[i].size){
              this.totalFileSize=this.totalFileSize+files[i].size
              let map = {};
              map.name = files[i].name
              map.size = files[i].size
              this.fileList.push(map)
            }else{
              for (let j=0;j< arr.length;j++){
                if(arr[j].name == files[i].name){
                  this.totalFileSize=this.totalFileSize+arr[j].size
                  let map = {};
                  map.name = arr[j].name
                  map.size = arr[j].size
                  this.fileList.push(map)
                  break
                }
              }
            }
          }

        }
      },
      getAllFileList(files){
        /*let that = this
        let arr = that.fileList;
        this.totalFileSize = 0;
        this.fileList = [];
        if(files){
          for (let i=0;i< files.length;i++){
            for (let j=0;j< arr.length;j++){
              if(arr[j].name == files[i].name||arr[j].name == files[i].uid){
                this.totalFileSize=this.totalFileSize+arr[j].size
                let map = {};
                map.name = arr[j].name
                map.size = arr[j].size
                this.fileList.push(map)
                break
              }
            }
          }
        }*/
      },
      handleFileDelete(file){
        /*if(file.size){
          this.totalFileSize=this.totalFileSize-file.size
        }else{
          for (let i=0;i< this.fileList.length;i++){
            let item = this.fileList[i];
            if(item.name == file.name||item.name == file.uid){
              this.totalFileSize=this.totalFileSize-item.size
              break;
            }
          }

        }*/

      },
      beforeUpload(file,data){
        // this.totalFileSize=this.totalFileSize+file.size
        /*let map = {};
        map.name = file.uid;
        map.size = file.size;
        this.fileList.push(map);*/
        /*if(this.totalFileSize>this.maxFileSize){
          this.$message.error("所有文件不能超过500M")
        }*/
      },
      add () {
        this.edit(this.modelDefault);
      },
      edit (record) {
        this.model = Object.assign({}, record);
        if(this.model.fileList&&this.model.fileList.length>0){
          this.model.fileList.forEach(item=>{
            this.totalFileSize=this.totalFileSize+item.fileSize
            let map = {}
            map.name = item.fileName
            map.size = item.fileSize
            this.fileList.push(map)
          })
        }
        /*if(this.model.systemCode){
          getAction("/sys/syscertificatelegalpersonsystems/getDataBySystemCode",{systemCode:this.model.systemCode}).then(res=>{
            if(res.success){
              // this.queryParam.certificateLegalpersonId = '';
              this.certificateLegalpersonlist = []
              let list = res.result;
              if(list){
                list.forEach(item=>{
                  let map = {};
                  map.value = item.legalperson
                  map.text = item.legalperson
                  this.certificateLegalpersonlist.push(map);
                })
              }
            }
          })
        }*/
        /*if(this.model.lock){
          this.islock = this.model.lock;
        }else{
          this.islock = false;
        }*/
        this.visible = true;
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            if(that.totalFileSize>that.maxFileSize){
              that.$message.error(this.language['sysCertificate.warning.totalFileSizeIs']+(that.totalFileSize/1024/1024).toFixed(2)+"M;"+this.language['sysCertificate.warning.CannotExceed']+(that.maxFileSize/1024/1024)+"M");
              return;
            }
            if(that.fileList.length>that.maxFileNumber){
              that.$message.error(this.language['sysCertificate.warning.totalFileSizeIs']+that.fileList.length+this.language['common.pcs']+";"+this.language['sysCertificate.warning.CannotExceed']+that.maxFileNumber+this.language['common.pcs']+","+this.language['sysCertificate.warning.uploadCompressedFiles'])
              return;
            }
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
              method = 'put';
            }
            that.model.certificateType=2
            httpAction(httpurl,that.model,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
    }
  }
</script>

